import { Box, CircularProgress, Typography } from '@mui/material'
import { useAppTheme, type LangKey } from '@/theme/ThemeContext'
import Logo from '@/assets/AppLogo.png'

const copy: Record<LangKey, string> = {
  he: 'מתחבר למערכת...',
  en: 'Connecting to the system...',
}

export default function AuthLoadingScreen() {
  const { mode, langKey } = useAppTheme()
  const isDark = mode === 'dark'

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        bgcolor: isDark ? '#0a1628' : '#F5FAFF',
      }}
    >
      <Box
        component="img"
        src={Logo}
        alt=""
        sx={{
          width: 72,
          height: 80,
          objectFit: 'cover',
          objectPosition: 'top',
          borderRadius: '50%',
        }}
      />
      <CircularProgress
        size={40}
        sx={{ color: isDark ? '#60A5FA' : '#254D88' }}
      />
      <Typography
        sx={{
          color: isDark ? '#BBD7FF' : '#0B4F6C',
          fontFamily: 'Rubik, sans-serif',
          fontSize: 'clamp(14px, 1vw, 18px)',
        }}
      >
        {copy[langKey]}
      </Typography>
    </Box>
  )
}
